'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputTypes = require('../../inputTypes');

var _attribute = require('../../attribute/attribute');

var _attribute2 = _interopRequireDefault(_attribute);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _attribute2.default)({
  type: _inputTypes.SELECT,
  attribute: 'contract_type',
  label: {
    default: 'Contract Type',
    short: 'Type'
  },
  options: [{
    value: 'standard',
    label: 'Standard'
  }, {
    value: 'reduced',
    label: 'Reduced Deductible'
  }, {
    value: 'minimum4Weeks',
    label: '4 Week Minimum'
  }]
}); // Attribute